namespace Areas.Eic {
    "use strict";

    var selected: Selected = new Selected();

    export function onUserIDValueChanged(rowData, value) {
        return userValueChanged(selected)(rowData, value);
    }

    export function userLookupEditTemplate(cellElement, cellInfo) {
        return lookupEditTemplate("/Eic/User/Users", selected)(cellElement, cellInfo);
    }

    export function userLookupCellTemplate(cellElement, cellInfo) {
        return lookupCellTemplate(cellElement, cellInfo);
    }

    export function newEicUser(e) {

        var dataGrid = $('#UserInfoGrid').dxDataGrid('instance');
        var eicId = dataGrid.option('EicId');

        e.data.eicId = eicId;
    }

    export function newEICRecharge(e) {

        var dataGrid = $('#EICRechargeInfoGrid').dxDataGrid('instance');
        var EicId = dataGrid.option('EicId');

        e.data.EicId = EicId;
    }
}